import classNames from "classnames";
import React from "react";
import styles from "../../styles/Form.module.css";

interface TextareaProps {
  autoComplete?: string;
  className?: string;
  disabled?: boolean;
  inError?: boolean;
  onBlur: () => void;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  requiredPlaceholder?: string;
  rows?: number;
  value?: string;
}

function Textarea({
  autoComplete = "",
  className = "",
  disabled = false,
  inError,
  onBlur,
  onChange,
  placeholder,
  requiredPlaceholder = "",
  rows = 3,
  required,
  value,
}: TextareaProps) {
  let placeholderVal = placeholder;
  if (!placeholderVal && required) placeholderVal = requiredPlaceholder;

  return (
    <textarea
      autoComplete={autoComplete}
      className={classNames(
        styles.input,
        className,
        { [styles.error]: inError },
        inError ? "placeholder-red-900/50" : "placeholder-gray-500/50",
        "shadow-sm block text-base border-gray-400 rounded-md",
      )}
      disabled={disabled}
      rows={rows}
      value={value || ""}
      onBlur={(e) => onBlur()}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholderVal}
    />
  );
}

export default Textarea;
